export class SettingFeatureFlags {
    manageOrderingConfigurations: boolean;
    enableFavouriteSampleManagement: boolean;
    enableTestPsorting: boolean;
}
